import {
  checkMeterStatus,
  GetAllmeter,
  Getmeter,
  meterRedaingExportReset,
  resetState,
  updateMeterStatus,
} from './../../../store/meters/meters.actions';

import { Component, ViewChild, Inject } from '@angular/core';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { metersData } from './meters-data';
import { Store, select } from '@ngrx/store';
import { SharedService } from '../../../shared/shared.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter as rxFilter } from 'rxjs/operators';

import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';

import {
  process,
  State,
  toODataString,
  SortDescriptor,
} from '@progress/kendo-data-query';
import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';

import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import {
  checkMeterStatusResponse,
  getAllmeterConfigResponse,
  getmeterConfigResponse,
  updateMeterStatusResponse,
} from '../../../store/meters/meters-selector';
import { PdfexportService } from '../../../core/services/pdfexport.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { table_pageSize } from '../../../shared/constants/templatesNames';
import {
  MeterheadersColumns,
  Roles,
  SweetAlertIcon,
  UtilityType,
} from '../../../shared/constants/enum';
import { Helper } from '../../../core/helpers/helper';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import { LoaderService } from '../../../core/services/loader.service';
import { MeterService } from '../../../core/services/meter.services';
import { HttpErrorResponse } from '@angular/common/http';
import { Validations } from '../../../shared/constants/validations';
import { __assign } from 'tslib';
import { debug } from 'console';
import { ChangeDetectorRef } from '@angular/core';
import _ from 'lodash';
import { NotificationService } from '../../../shared/notification.service';

@Component({
  selector: 'app-rp-meters',
  templateUrl: './rp-meters.component.html',
  styleUrl: './rp-meters.component.scss',
  standalone: false,
})
export class RpMetersComponent {
  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  public selectableSettings: SelectableSettings = {
    mode: 'multiple',
    checkboxOnly: true,
  };
  UtilityType = UtilityType;
  breadCrumbItems: Array<{}> | undefined;
  public checkboxOnly = true;
  public drag = false;
  public mode: SelectableMode = 'multiple';
  selectValue!: string[];
  public meterState: any = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  currentUser: any;
  projectId: any;
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  public pageSize = 10;
  public skip = 0;
  totalMasterCount: number = 0;
  currentPage: number = 1;
  meterconfigList: any[] = [];
  public sort: SortDescriptor[] = [];
  public metergridData: GridDataResult = { data: [], total: 0 };
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  public state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  public buttonCount = 5;
  listOfRoles = Roles;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public pageSizes = table_pageSize.pageSizes;
  //public pageSizes = true;
  public previousNext = true;
  mySelectionMeter: any = [];
  orderByQuery: string = '';
  queryString: string = '';
  searchedValue: any = '';
  allMeterconfigList: any[] = [];
  userRole: string = '';
  ServiceError = Validations.ServiceError;
  meterRequest = Object.assign({});
  selectedMeter: any;
  MeterheadersColumns = MeterheadersColumns;
  private lastAppliedMacAddress: string | null = null;
  constructor(
    private store: Store,
    private sharedService: SharedService,
    private notificationService: NotificationService,
    private router: Router,
    private PdfexportService: PdfexportService,
    private loaderService: LoaderService,
    private meterService: MeterService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    if (
      history.state.meterRequest != undefined &&
      history.state.meterRequest !== null
    ) {
      this.meterRequest = history.state.meterRequest;
    }
    this.isFilter = localStorage.getItem('filter');

    // console.log(this.meterRequest)
    this.getStoreInfo();
    this.breadCrumbItems = [{ label: 'Meters' }];
    this.router.events
      .pipe(rxFilter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.router.url.startsWith('/meters')) {
          this.applyNotificationFilterIfAny();
        }
      });
  }
  private exportSubscription: Subscription = new Subscription();
  private MetersConfiguration$: Subscription = new Subscription();

  isEvUtility(item: any): boolean {
    return (item?.utility ?? '').toString().trim().toLowerCase() === 'ev';
  }

  getStoreInfo() {
    this.store.dispatch(resetState());
  }
  isFilter: any;
  ishide: boolean = true;
  ngOnInit(): void {
    this.notificationService.emitNotificationUpdate();
    this.sharedService.setMeterViewDetails(null);
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.projectId = this.currentUser?.project?.id;
    this.userRole = this.currentUser?.currentUserRoleDetails?.role;
    console.log(this.meterRequest);
    console.log(this.projectId);
    const macAddress = this.getNotificationMacAddress();
    if (macAddress) {
      this.applyMacAddressFilter(macAddress);
    } else if (
      this.meterRequest &&
      typeof this.meterRequest === 'object' &&
      Object.keys(this.meterRequest).length > 0
    ) {
      this.applyFilter(this.meterRequest);
    }
    const savedFilter = this.sharedService.getFilters('MeterPage');
    if (this.isFilter == 'true' && savedFilter) {
      this.meterState.filter = savedFilter;
      console.log(this.filter);
      console.log(this.meterState);
      this.queryString = this.sharedService.createQuery(this.meterState);
    }

    this.getAllMeterConfigurations();
  }

  private applyNotificationFilterIfAny(): void {
    const macAddress = this.getNotificationMacAddress();
    if (macAddress) {
      this.applyMacAddressFilter(macAddress);
    }
  }

  private normalizeMacAddress(value: string): string {
    return value.replace(/[^0-9a-fA-F]/g, '').toUpperCase();
  }

  private getNotificationMacAddress(): string | null {
    const navigationState =
      this.router.getCurrentNavigation()?.extras?.state || history.state;

    if (!navigationState || navigationState.from !== 'notifications') {
      return null;
    }

    const info = navigationState.info ?? navigationState.data ?? navigationState;
    if (!info) {
      return null;
    }

    if (typeof info === 'string') {
      return info.trim() ? this.normalizeMacAddress(info.trim()) : null;
    }

    const infoPayload = info.data ?? info.payload ?? info.notification ?? info;
    const macAddress =
      infoPayload.macAddress ||
      infoPayload.mac_address ||
      infoPayload.deviceMacAddress ||
      infoPayload.deviceMac ||
      infoPayload.mac;

    if (typeof macAddress === 'string' && macAddress.trim().length > 0) {
      return this.normalizeMacAddress(macAddress.trim());
    }

    const textSource =
      infoPayload.description ||
      infoPayload.message ||
      infoPayload.title ||
      '';
    const match = String(textSource).match(/[0-9A-F]{16}/i);
    return match ? this.normalizeMacAddress(match[0]) : null;
  }

  private applyMacAddressFilter(macAddress: string): void {
    if (this.lastAppliedMacAddress === macAddress) {
      return;
    }
    this.lastAppliedMacAddress = macAddress;
    this.searchedValue = '';
    this.searchModifiedData = '';
    this.meterState.filter = {
      logic: 'and',
      filters: [
        {
          field: 'macAddress',
          operator: 'eq',
          value: macAddress,
        },
      ],
    };
    this.filter = this.meterState.filter;
    this.onMeterFilterChange(this.meterState.filter);
  }

  applyFilter(meterRequest: any) {
    console.log(meterRequest);
    if (meterRequest.type == 'Admin_dashboard') {
      console.log(meterRequest);
      this.ishide = meterRequest.type == 'dashboard' ? false : true;

      this.meterState = {
        skip: 0,
        take: 10,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'utility',
                  operator: 'contains',
                  value: meterRequest.utility,
                },
              ],
              logic: 'and',
            },
            {
              filters: [
                {
                  field: 'meterSatus',
                  operator: 'contains',
                  value: meterRequest.meterStatus,
                },
              ],
              logic: 'and',
            },
          ],
          logic: 'and',
        },
      };

      this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and meterSatus eq '${meterRequest.meterStatus}')`;
    } else if (meterRequest.type == 'Admin_Meter') {
      this.meterState = {
        skip: 0,
        take: 10,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'utility',
                  operator: 'contains',
                  value: 'Electricity',
                },
              ],
              logic: 'and',
            },
            {
              filters: [{ field: 'mcbStatus', operator: 'eq', value: false }],
              logic: 'and',
            },
          ],
          logic: 'and',
        },
      };
      this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and mcbStatus eq '${meterRequest.status}')`;
    } else if ((meterRequest.type = 'superAdmin_Meter')) {
      console.log(meterRequest.utility);
      console.log(meterRequest);
      if (meterRequest.utility == 'All') {
        switch (meterRequest.value) {
          case 'Communicating':
            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  {
                    filters: [
                      {
                        field: 'meterCommunicationStatus',
                        operator: 'eq',
                        value: true,
                      },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };
            this.queryString = `$filter=meterCommunicationStatus eq true`;
            break;
          case 'Non Communicating':
            this.ishide = false;
            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  {
                    filters: [
                      {
                        field: 'meterCommunicationStatus',
                        operator: 'eq',
                        value: false,
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      { field: 'meterSatus', operator: 'eq', value: 'Active' },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      { field: 'mcbStatus', operator: 'contains', value: 'ON' },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };
            this.queryString = `$filter=(meterCommunicationStatus eq false and meterSatus eq 'Active' and contains(mcbStatus,'ON'))`;

            //(meterCommunicationStatus eq false and meterSatus eq 'Active' and contains(mcbStatus,'ON'))

            //(meterSatus eq 'Active' and meterCommunicationStatus eq false)
            // let dt='(meterCommunicationStatus eq false and contains(meterSatus,'Active'))'
            break;

          case 'Inactive':
            console.log(meterRequest);
            this.ishide = false;

            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  {
                    filters: [
                      {
                        field: 'meterCommunicationStatus',
                        operator: 'eq',
                        value: false,
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'mcbStatus',
                        operator: 'eq',
                        value: 'ON',
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'meterSatus',
                        operator: 'contains',
                        value: 'Inactive',
                      },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };
            // this.queryString = `$filter=(meterCommunicationStatus eq false and mcbMainPower eq true and contains(meterSatus,'Inactive'))`;

            this.queryString = `$filter=(meterCommunicationStatus eq false and meterSatus eq 'Inactive' and (mcbStatus eq 'ON'))`;

            break;
          case 'MCB Off':
            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  /* {
                    filters: [
                      {
                        field: 'meterCommunicationStatus',
                        operator: 'eq',
                        value: false,
                      },
                    ],
                    logic: 'and',
                  }, */
                  {
                    filters: [
                      { field: 'mcbStatus', operator: 'eq', value: false },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };
            //(mcbStatus eq 'On' or mcbStatus eq null or mcbStatus eq '' )
            // this.queryString = `$filter=(meterCommunicationStatus eq false and mcbStatus eq 'Off')`;
            this.queryString = `$filter=(mcbStatus eq 'Off')`;
            break;

          default:
            // fallback logic for unknown value
            console.warn('Unknown meter status:', meterRequest.value);
            break;
        }
      } else {
        /*    switch (meterRequest.value) {
          case 'Communicating':
            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  {
                    filters: [
                      {
                        field: 'utility',
                        operator: 'eq',
                        value: meterRequest.utility,
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'meterCommunicationStatus',
                        operator: 'eq',
                        value: true,
                      },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };
            this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq true)`;

            break;
          case 'Non Communicating':
            this.ishide = false;
           
            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  {
                    filters: [
                      {
                        field: 'utility',
                        operator: 'eq',
                        value: meterRequest.utility,
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'meterCommunicationStatus',
                        operator: 'eq',
                        value: false,
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'mcbStatus',
                        operator: 'eq',
                        value: 'ON',
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'meterSatus',
                        operator: 'contains',
                        value: 'Active',
                      },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };
            //  this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq false and mcbMainPower eq true and contains(meterSatus,'Active'))`;

            this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq false and meterSatus eq 'Active' and (mcbStatus eq 'ON'))`;

            break;

          case 'Inactive':
            this.ishide = false;

            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  {
                    filters: [
                      {
                        field: 'utility',
                        operator: 'contains',
                        value: meterRequest.utility,
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'meterCommunicationStatus',
                        operator: 'eq',
                        value: false,
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'mcbStatus',
                        operator: 'eq',
                        value: 'ON',
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'meterSatus',
                        operator: 'contains',
                        value: 'Inactive',
                      },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };
            this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq false and meterSatus eq 'Inactive' and (mcbStatus eq 'ON'))`;

           
            break;
          case 'MCB Off':
            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  {
                    filters: [
                      {
                        field: 'utility',
                        operator: 'contains',
                        value: meterRequest.utility,
                      },
                    ],
                    logic: 'and',
                  },

                 
                  {
                    filters: [
                      {
                        field: 'mcbStatus',
                        operator: 'eq',
                        value: 'Off',
                      },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };

            this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and mcbStatus eq 'Off')`;
           

            break;

          default:
            
            console.warn('Unknown meter status:', meterRequest.value);
            break;
        } */

        console.log(meterRequest); // { value: 'Inactive', type: 'superAdmin_Meter', utility: 'Gas' }

        switch (meterRequest.value) {
          case 'Communicating':
            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: [
                  {
                    filters: [
                      {
                        field: 'utility',
                        operator: 'eq',
                        value: meterRequest.utility,
                      },
                    ],
                    logic: 'and',
                  },
                  {
                    filters: [
                      {
                        field: 'meterCommunicationStatus',
                        operator: 'eq',
                        value: true,
                      },
                    ],
                    logic: 'and',
                  },
                ],
                logic: 'and',
              },
            };

            this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq true)`;
            break;

          case 'Non Communicating':
            this.ishide = false;

            // ✅ Skip MCB filters for Gas and Water
            const nonComFilters: any[] = [
              {
                filters: [
                  {
                    field: 'utility',
                    operator: 'eq',
                    value: meterRequest.utility,
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'meterCommunicationStatus',
                    operator: 'eq',
                    value: false,
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'meterSatus',
                    operator: 'contains',
                    value: 'Active',
                  },
                ],
                logic: 'and',
              },
            ];

            if (
              meterRequest.utility === 'Electricity' ||
              meterRequest.utility === 'TriSource'
            ) {
              // ✅ Only add MCB filter for Electricity or TriSource
              nonComFilters.push({
                filters: [
                  {
                    field: 'mcbStatus',
                    operator: 'eq',
                    value: 'ON',
                  },
                ],
                logic: 'and',
              });
            }

            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: nonComFilters,
                logic: 'and',
              },
            };

            this.queryString =
              meterRequest.utility === 'Electricity' ||
                meterRequest.utility === 'TriSource'
                ? `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq false and meterSatus eq 'Active' and mcbStatus eq 'ON')`
                : `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq false and meterSatus eq 'Active')`;

            break;

          case 'Inactive':
            this.ishide = false;

            const inactiveFilters: any[] = [
              {
                filters: [
                  {
                    field: 'utility',
                    operator: 'contains',
                    value: meterRequest.utility,
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'meterCommunicationStatus',
                    operator: 'eq',
                    value: false,
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'meterSatus',
                    operator: 'contains',
                    value: 'Inactive',
                  },
                ],
                logic: 'and',
              },
            ];

            if (
              meterRequest.utility === 'Electricity' ||
              meterRequest.utility === 'TriSource'
            ) {
              inactiveFilters.push({
                filters: [
                  {
                    field: 'mcbStatus',
                    operator: 'eq',
                    value: 'ON',
                  },
                ],
                logic: 'and',
              });
            }

            this.meterState = {
              skip: 0,
              take: 10,
              filter: {
                filters: inactiveFilters,
                logic: 'and',
              },
            };

            this.queryString =
              meterRequest.utility === 'Electricity' ||
                meterRequest.utility === 'TriSource'
                ? `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq false and meterSatus eq 'Inactive' and mcbStatus eq 'ON')`
                : `$filter=(contains(utility,'${meterRequest.utility}') and meterCommunicationStatus eq false and meterSatus eq 'Inactive')`;

            break;

          case 'MCB Off':
            // ✅ MCB Off only applies to Electricity and TriSource
            if (
              meterRequest.utility === 'Electricity' ||
              meterRequest.utility === 'TriSource'
            ) {
              this.meterState = {
                skip: 0,
                take: 10,
                filter: {
                  filters: [
                    {
                      filters: [
                        {
                          field: 'utility',
                          operator: 'contains',
                          value: meterRequest.utility,
                        },
                      ],
                      logic: 'and',
                    },
                    {
                      filters: [
                        {
                          field: 'mcbStatus',
                          operator: 'eq',
                          value: 'Off',
                        },
                      ],
                      logic: 'and',
                    },
                  ],
                  logic: 'and',
                },
              };

              this.queryString = `$filter=(contains(utility,'${meterRequest.utility}') and mcbStatus eq 'Off')`;
            } else {
              // ✅ Skip MCB Off logic for Gas and Water
              console.warn(
                `MCB Off not applicable for ${meterRequest.utility}`
              );
              this.meterState = null;
              this.queryString = '';
            }
            break;

          default:
            console.warn('Unknown meter status:', meterRequest.value);
            break;
        }
      }
    }
  }

  isValidDate(date: any): boolean {
    return date && !isNaN(new Date(date).getTime());
  }

  ngOnDestroy() {
    this.sharedService.setMeterViewDetails(null);
    this.exportSubscription.unsubscribe(); // Or set it to [] if you prefer an empty array
    let filter: CompositeFilterDescriptor = {
      filters: [],
      logic: 'and',
    };
    this.sharedService.setFilter(filter);
    this.store.dispatch(meterRedaingExportReset());
    this.MetersConfiguration$.unsubscribe();
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();

      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }
  navigateToMeterView(dataItem: any): void {
    console.log('dataItem', dataItem);

    const serializedData = JSON.stringify(dataItem);
    this.router.navigate(['/meters/metersView'], {
      state: { meterViewDetails: serializedData },
    });
  }

  onSortChange(sort: SortDescriptor[]): void {
    this.meterState.sort = sort;
    console.log(this.meterState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.meterState.sort
    );

    this.orderByQuery = orderByQuery;

    this.getAllMeterConfigurations();
  }

  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];

  async onMeterFilterChange(filter: CompositeFilterDescriptor) {
    this.meterState.filter = filter;
    console.log('this.meterState--->', this.meterState);
    this.skip = 0;
    this.currentPage = 1;

    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };

    let isFilter = filter.filters.length > 0 ? true : false;
    localStorage.setItem('filter', JSON.stringify(isFilter));
    localStorage.setItem('page', 'Meter');

    this.sharedService.setFilters('MeterPage', filter);
    this.customFilterState = _.cloneDeep(this.meterState);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.meterState
    );
    // console.log("temp-------------->", filterOperators)
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        console.log('gasQueryString', this.customDateFiltersQueryEq);
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          console.log('gasQueryString', this.customDateFiltersQueryNEQ);
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ
        );
      this.queryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.queryString = this.sharedService.createQuery(this.customFilterState);
    }

    console.log(this.meterState);

    //const queryString = this.sharedService.createQuery(this.meterState);

    this.getAllMeterConfigurations();
    console.log(this.queryString);
  }
  public onValueChange(ev: string): void {
    console.log(ev);
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.meterConfigPageChange({ skip: 0, take: this.pageSize });
      // this.getProjectsList();
    }

    /*  if (ev.length == 0) {
      this.searchModifiedData = '';
      this.meterConfigPageChange({ skip: 0, take: this.pageSize });
      this.getAllMeterConfigurations();
    } */
  }
  private triggerSearch(): void {
    const trimmedValue = this.searchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.searchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.searchedValue.length === 0) {
      this.meterConfigPageChange({ skip: 0, take: this.pageSize });
      // this.getProjectsList();
      return;
    }

    // Otherwise — run search
    this.getAllMeterConfigurations();
  }

  onSearchMeterAds(): void {
    this.triggerSearch();
    /* if (this.searchedValue.length > 0) {
      this.searchMeters();
      //this.getAllMeterConfigurations()
    } */
  }
  searchModifiedData: string = '';
  searchMeters(): void {
    const trimmedValue = this.searchedValue
      .replace(/^(\d+(\.\d+)?)\s?(kWh|L|m³)$/, '$1')
      .trim();
    this.searchModifiedData;
    if (trimmedValue) {
      // Extract the numeric part from the match
      const numericValue = trimmedValue;
      // Format the numeric value as required (e.g., "5.67 KWh ,L..")
      this.searchModifiedData = numericValue;
      console.log(this.searchModifiedData);
    } else {
      // If the input doesn't match any special patterns, keep it as is
      this.searchModifiedData = this.searchedValue;
      console.log(this.searchModifiedData);
    }
    this.getAllMeterConfigurations();
    /* this.store.dispatch(
      Getmeter({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchModifiedData,
        filter: this.queryString,
        orderBy: this.orderByQuery,
        projectId: this.projectId,
      })
    ); */
  }

  getAllMeterConfigurations(): void {
    this.loaderService.setLoading(true);
    // console.log(this.searchedValue, this.projectId);
    this.meterService
      .getMeters(
        this.currentPage,
        this.pageSize,
        this.searchedValue,
        this.projectId,
        this.queryString,
        this.orderByQuery
      )
      .subscribe({
        next: (res) => {
          //console.log("hdskhddkadkjsakdjsad------------>",res);
          if (res.statusCode == 200) {
            // console.log('hdskhddkadkjsakdjsad------------>', res);
            this.meterconfigList = [];
            this.meterconfigList = [...res.data.items];
            this.loaderService.setLoading(false);
            //console.log("-------------------------------->",this.meterconfigList);
            this.pageSize = res.data.pageSize;
            this.totalMasterCount = res.data.totalCount;
            this.loadMterConfig();
            let selectedMeter = this.sharedService.getMeterViewDetails()
              ? JSON.parse(this.sharedService.getMeterViewDetails())
              : null;
            console.log('selectedMeter---------->', selectedMeter);
            if (selectedMeter) {
              // need to implement check meter status response
              selectedMeter = this.meterconfigList.find(
                (item: any) => item.id == selectedMeter.id
              );
              console.log(selectedMeter);
              // let message = selectedMeter.utility + ' Meter Status is ' + (selectedMeter.valveOrRelayStatus ? 'On' : 'Off');
              let message = '';

              if (selectedMeter.utility === 'Electricity') {
                message =
                  'Electricity Meter Relay Status is ' +
                  (selectedMeter.valveOrRelayStatus ? 'On' : 'Off');
              } else if (selectedMeter.utility === 'Gas') {
                message =
                  'Gas Meter Valve Status is ' +
                  (selectedMeter.valveOrRelayStatus ? 'On' : 'Off');
              } else {
                message =
                  selectedMeter.utility +
                  ' Meter Status is ' +
                  (selectedMeter.valveOrRelayStatus ? 'On' : 'Off');
              }

              console.log(message);

              this.sharedService.showMessageDialog(
                message,
                '',
                SweetAlertIcon.INFO
              );

              this.sharedService.setMeterViewDetails(null);

            }

          } else {
            this.loaderService.setLoading(false);
          }
          this.changeDetectorRef.detectChanges();
          //this.loaderService.setLoading(false);
          console.log('MetersConfiguration', res);
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });
  }

  public clearFilter(): void {
    this.searchedValue = '';
    this.queryString = '';
    this.orderByQuery = '';

    // Reset filter state
    this.meterState.filter = { logic: 'and', filters: [] }; // Correctly reset to a filter descriptor
    this.meterState.sort = []; // Reset sorting if needed
    this.skip = 0; // Reset to first page
    this.currentPage = 0;

    // Clear additional filter if required
    this.filter = { logic: 'and', filters: [] }; // Reset additional filter state

    // Fetch all configurations again to refresh the grid
    this.getAllMeterConfigurations();
  }

  getTotalMeterConfigurations(): void {
    let filetr: any;
    if (this.meterRequest.type == 'dashboard') {
      filetr = this.queryString;
    } else {
      filetr = '';
    }

    console.log(this.projectId);
    this.loaderService.setLoading(true);
    this.meterService
      .getMeters(1, undefined, '', this.projectId, filetr, this.queryString)
      .subscribe({
        next: (res) => {
          console.log(res);
          if (res) {
            this.loaderService.setLoading(false);
            this.allMeterconfigList = [];
            if (res?.data.items.length > 0) {
              this.allMeterconfigList = res.data.items;
              console.log(this.allMeterconfigList);
              const exportData = this.allMeterconfigList
                .map((item: any) => {
                  const dataMap = new Map<string, string>();

                  // Add values with condition
                  if (item?.projectName != null)
                    dataMap.set('Project Name', item.projectName);
                  if (item?.utility != null)
                    dataMap.set('Utility', item.utility);
                  if (item?.deviceSrNo != null)
                    dataMap.set('Device Sr No', item.deviceSrNo);
                  if (item?.macAddress != null)
                    dataMap.set('MAC Address', item.macAddress);
                  if (item?.meterSatus != null)
                    dataMap.set('Status', item.meterSatus);

                  if (item?.currentReading != null) {
                    const reading =
                      item.utility === 'Water'
                        ? item.currentReading + ' L'
                        : item.utility === 'Gas'
                          ? item.currentReading + ' m³'
                          : item.utility === 'Electricity' ||
                            item.utility === 'TriSource'
                            ? '-'
                            : '';
                    dataMap.set('Reading', reading);
                  }

                  if (item?.currentReadingEB != null) {
                    const ebReading =
                      item.utility === 'Electricity' ||
                        item.utility === 'TriSource'
                        ? item.currentReadingEB + ' kWh'
                        : '';
                    dataMap.set('EB Reading', ebReading);
                  }

                  if (item?.currentReadingDG != null) {
                    const dgReading =
                      item.utility?.toLowerCase() === 'electricity' ||
                        item.utility?.toLowerCase() === 'trisource'
                        ? item.currentReadingDG + ' kWh'
                        : '';
                    dataMap.set('DG Reading', dgReading);
                  }

                  if (item?.currentReadingSolar != null) {
                    const solarReading =
                      item.utility === 'TriSource'
                        ? item.currentReadingSolar + ' kWh'
                        : '-';
                    dataMap.set('Solar Readings', solarReading);
                  }

                  if (item?.occupant != null)
                    dataMap.set('Occupant', item.occupant);

                  if (item?.currentDate != null) {
                    const formattedDate = this.sharedService.dateFormateChnage(
                      item.currentDate
                    );
                    dataMap.set('Last Communicated Date', formattedDate);
                  }

                  if (item?.residentialUnit != null)
                    dataMap.set('Residential Unit', item.residentialUnit);

                  if (item?.mcbStatus != null && item.mcbStatus !== '') {
                    const mcbStatus =
                      item.utility === 'Electricity' ||
                        item.utility === 'TriSource'
                        ? item.mcbStatus
                        : '-';
                    dataMap.set('MCB Status', mcbStatus);
                  }

                  if (item?.onRequest != null)
                    dataMap.set('On Request Sent', item.onRequest);
                  if (item?.offRequest != null)
                    dataMap.set('Off Request Sent', item.offRequest);

                  if (item?.batterLevel != null) {
                    const batteryLevel =
                      item.utility !== 'Electricity' &&
                        item.utility !== 'TriSource'
                        ? item.batterLevel
                        : '-';
                    dataMap.set('Battery Level', batteryLevel);
                  }

                  if (item?.batteryVoltage != null) {
                    const batteryVolt =
                      item.utility !== 'Electricity' &&
                        item.utility !== 'TriSource'
                        ? item.batteryVoltage + ' v'
                        : '-';
                    dataMap.set('Battery Voltage', batteryVolt);
                  }

                  if (item?.meterCommunicationStatus != null) {
                    dataMap.set(
                      'Communication Status',
                      this.isEvUtility(item) ? '-' : item.meterCommunicationStatus ? 'Yes' : 'No'
                    );
                  }

                  if (item?.valveOrRelayStatus != null) {
                    const valveRelay =
                      this.isEvUtility(item)
                        ? '-'
                        : item.utility === 'Water'
                          ? '-'
                          : item.valveOrRelayStatus
                            ? 'ON'
                            : 'OFF';
                    dataMap.set('Valve/Relay Status', valveRelay);
                  }

                  // Convert Map to ordered object
                  const orderedObj: any = {};
                  this.MeterheadersColumns.forEach((key) => {
                    orderedObj[key] = dataMap.get(key) ?? '';
                  });

                  return orderedObj;
                })
                .filter((item: { [s: string]: unknown } | ArrayLike<unknown>) =>
                  Object.values(item).some((val) => val !== '')
                );

              // You can now use `exportData` for Excel export or table rendering
              console.log(exportData);

              this.allMeterconfigList = [];

              // Check if there's data to export after filtering null values
              if (exportData.length > 0) {
                this.PdfexportService.downloadExcel(exportData, 'Meters');
              } else {
                this.sharedService.showMessageDialog(
                  'No valid data to export',
                  '',
                  SweetAlertIcon.ERROR
                );
              }
            } else {
              this.sharedService.showMessageDialog(
                'No data to display',
                '',
                SweetAlertIcon.ERROR
              );
            }
          }
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);
        },
      });

    /* this.store.dispatch(
      GetAllmeter({
        pageIndex: 1,
        pageSize: undefined,
        searchTerm: '',
        filter: filetr,
        orderBy: '',
        projectId: this.projectId,
      })
    ); */
  }

  public onFilterChange(filter: CompositeFilterDescriptor): void {
    this.state.filter = filter;
    const queryString = this.createQuery(this.state);
    console.log(queryString);
  }

  private createQuery(state: State): string {
    // Implement this method to create a query string from the state object
    // This should convert the state to your API's query parameters
    // Example implementation
    const queryStr = `${toODataString(state)}&$count=true`;
    console.log(queryStr);

    let query = `skip=${state.skip}&take=${state.take}`;

    if (state?.filter) {
      const filters = state.filter.filters
        .map((f) => {
          const field = (f as any).field;
          const value = (f as any).value;
          return `${field}=${value}`;
        })
        .join('&');
      query += `&${filters}`;
    }

    return query;
  }

  protected meterConfigPageChange({ skip, take }: PageChangeEvent): void {
    console.log('>>>', skip, take);
    this.mySelectionMeter = [];
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);

    this.searchModifiedData != ''
      ? this.searchModifiedData
      : this.searchedValue,
      this.getAllMeterConfigurations();
    /* this.store.dispatch(
      Getmeter({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm:
         
        filter: this.queryString,
        orderBy: this.orderByQuery,
        projectId: this.projectId,
      })
    ); */
    /*  this.loadMterConfig(); */
  }

  public selectionChanged(selection: any) {
    // Handle deselected rows
    selection.deselectedRows.forEach((row: any) => {
      const index = this.mySelectionMeter.findIndex(
        (selectedRow: any) => selectedRow.id === row.dataitem?.id
      );
      if (index > -1) {
        this.mySelectionMeter.splice(index, 1);
      }
    });

    // Handle selected rows
    selection.selectedRows.forEach((row: any) => {
      if (!this.isMasterRowSelected(row.dataItem)) {
        this.mySelectionMeter.push(row.dataItem);
      }
    });

    console.log(this.mySelectionMeter);
  }

  protected dataStateChange(state: DataStateChangeEvent): void {
    console.log('saAK', JSON.stringify(state.filter));
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    console.log('datastatechange' + JSON.stringify(this.filter));
    // alert('datastatechange'+JSON.stringify(this.filter))
    //this.loadMterConfig();
  }

  private loadMterConfig(): void {
    // const state: State = {
    // console.log(this.meterconfigList);
    const state: State = {
      take: this.pageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
    };

    const processedData = process(this.meterconfigList, state);
    // console.log("meterconfigList",JSON.stringify(this.meterconfigList));
    //console.log("processed",JSON.stringify(processedData));
    // alert("santosh"+JSON.stringify(processedData))
    this.metergridData = {
      data: processedData.data,
      total: this.totalMasterCount,
    };
    // console.log(new Date(project.currentDate));
    this.metergridData.data = this.metergridData?.data.map((project) => {
      // console.log(new Date(project.currentDate));
      let status: 'On' | 'Off';

      if (project.utility === 'Water') {
        status =
          project.valveOrRelayStatus === null ||
            project.valveOrRelayStatus === undefined ||
            project.valveOrRelayStatus === ''
            ? 'On'
          : project.valveOrRelayStatus === true ? 'On' : 'Off';
      } else {
        status = project.valveOrRelayStatus === true ? 'On' : 'Off';
      }

      console.log('status------>', status);
      const isEv = this.isEvUtility(project);

      return {
        ...project,
        valveOrRelayStatus: isEv ? '-' : status,

        currentDate: project?.currentDate ? new Date(project.currentDate) : '-', // Modify the billDate property
        communicationStatus: isEv ? '-' : project.meterCommunicationStatus ? 'Yes' : 'No',
        currentReading:
          project.utility === 'Water'
            ? project.currentReading != null
              ? project.currentReading + ' L'
              : '-'
            : project.utility === 'Gas'
              ? project.currentReading != null
                ? project.currentReading + ' m³'
                : '-'
              : project.utility === 'Electricity' ||
                project.utility === 'TriSource'
                ? '-'
                : '',
        currentReadingEB:
          project.utility === 'Electricity' || project.utility === 'TriSource'
            ? project.currentReadingEB != null
              ? project.currentReadingEB + ' kWh'
              : '-'
            : '-',

        currentReadingDG:
          project.utility === 'Electricity' || project.utility === 'TriSource'
            ? project.currentReadingDG != null
              ? project.currentReadingDG + ' kWh'
              : '-'
            : '-',

        currentReadingSolar:
          project.utility === 'Electricity' || project.utility === 'TriSource'
            ? project.currentReadingSolar != null
              ? project.currentReadingSolar + ' kWh'
              : '-'
            : '-',

        mcbStatus:
          project.utility === 'Electricity' || project.utility === 'TriSource'
            ? project.mcbStatus === null || project.mcbStatus.trim() === ''
              ? 'ON'
              : project.mcbStatus.toUpperCase()
            : '-',
        /* valveOrRelayStatus:
          project.utility == 'Water'
            ? '-'
            : project.valveOrRelayStatus
            ? 'On'
            : 'Off', */
        // valveOrRelayStatus: status,

        current_Date:
          project.currentDate != null
            ? this.sharedService.dateFormateChnage(project.currentDate)
            : '-',
        battery_Voltage:
          project.utility == 'Electricity' || project.utility === 'TriSource'
            ? '-'
            : project.batteryVoltage,
        batter_Level:
          project.utility == 'Electricity' || project.utility === 'TriSource'
            ? '-'
            : project.batterLevel,
      };
    });
    console.log(this.metergridData);

  }

  public isMasterRowSelected = (rowArg: any) => {
    return this.mySelectionMeter.some((row: any) => row.id === rowArg.id);
  };

  public onMeterConfigFilter(value: any): void {
    this.searchModifiedData = this.searchedValue;
    const trimmedValue = this.searchModifiedData
      .replace(/^(\d+(\.\d+)?)\s?(kWh|L|m³)$/, '$1')
      .trim()
      .trim();
    if (trimmedValue) {
      // Extract the numeric part from the match
      const numericValue = trimmedValue;
      // Format the numeric value as required (e.g., "5.67 KWh ,L..")
      this.searchModifiedData = numericValue;
      console.log(this.searchModifiedData);
    } else {
      // If the input doesn't match any special patterns, keep it as is
      this.searchModifiedData = this.searchedValue;
      console.log(this.searchModifiedData);
    }

    this.triggerSearch();
    // this.meterConfigPageChange({ skip: 0, take: this.pageSize });
    //this.getAllMeterConfigurations();
  }
  exportAll() {
    this.getTotalMeterConfigurations();
  }

  public onMeterPdfExport(type: string) {
    if (type === 'Excel') {
      if (this.metergridData.data.length > 0) {
        setTimeout(() => {
          this.hiddenGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.hiddenGrid?.saveAsPDF();
      }, 1000);
    }
  }

  turOnMeter(event: any, dataItem: any) { }

  toggleMeterStatus(event: any, dataItem: any) {
    this.loaderService.setLoading(true);
    console.log(event);
    console.log(this.projectId);
    let request = {
      meterId: dataItem?.id,
      status: event,
      macAddress: dataItem.macAddress,
      utilityName: dataItem.utility,
      IsConsumer: false,
      ProjectId:
        this.projectId == undefined ? dataItem.projectId : this.projectId,
    };
    // this.store.dispatch(updateMeterStatus({ request: request }));

    this.meterService.updateMeterStatus(request).subscribe({
      next: (res) => {
        if (res) {
          console.log(request.status);
          this.sharedService.showMessageDialog(
            request.status == 'On' ? 'ON Request sent' : ' OFF Request sent.',
            res,
            SweetAlertIcon.SUCCESS
          );

          this.meterconfigList = this.meterconfigList.map((meter) => {
            if (meter.id === res.data.id) {
              return {
                ...meter,
                onRequest: res.data.onRequest,
                onRequestDate: res.data.onRequestDate,
                offRequest: res.data.offRequest,
                offRequestDate: res.data.offRequestDate,
              };
            }
            return meter;
          });
        }
        this.loadMterConfig();
        this.loaderService.setLoading(false);
      },
      error: (err) => {
        this.loaderService.setLoading(false);
        const errorMessage = this.sharedService.getApiErrorMessage(err);
        this.sharedService.showMessageDialog(
          'Failure',
          errorMessage,
          SweetAlertIcon.ERROR
        );
      },
    });
  }

  checkRelayStatus(dataItem: any) {
    this.sharedService.setMeterViewDetails(JSON.stringify(dataItem));
    let request = {
      MacAddress: dataItem?.macAddress,
      IsConsumer: false,
      ProjectId: dataItem?.projectId,
    };
    this.loaderService.setLoading(true);
    // this.store.dispatch(checkMeterStatus({ request: request }));
    this.meterService.checkMeterStatus(request).subscribe({
      next: (response) => {
        // Handle the response and show a success alert
        setTimeout(() => {
          this.getAllMeterConfigurations();
        }, 30000);
      },
      error: (error: HttpErrorResponse) => {
        // Handle error and display error alert
        this.loaderService.setLoading(false);
        this.sharedService.showMessageDialog(
          error.message,
          this.ServiceError.Error,
          SweetAlertIcon.ERROR
        );
        console.error('Error occurred:', error);
      },
    });
    // }
  }

  checkBtnStatus(dataItem: any): boolean {
    if (dataItem?.onRequest === 'Yes' && !dataItem?.valveOrRelayStatus) {
      return true; // Button for turning on, so toggle off
    }
    if (dataItem?.offRequest === 'Yes' && dataItem?.valveOrRelayStatus) {
      return true; // Button for turning off, so toggle on
    }
    return dataItem?.valveOrRelayStatus; // Otherwise, keep the current status
  }
}
